import { useCallback, useEffect, useState } from 'react'
import type { LoanViewFilters } from '../types'
import { _getLoanShareCalculation } from 'state/finance-loan.actions'
import type { LoanCalculation } from '@viilu-web/shared'

function useLoanShareCalculation(
	loanUUID: string,
	filters: LoanViewFilters,
	disabled?: boolean,
) {
	const [calculation, setCalculation] = useState<LoanCalculation | null>(null)

	const [loading, setLoading] = useState<boolean>(false)
	const [error, setError] = useState<string | null>(null)

	const doQuery = useCallback(async () => {
		setLoading(true)
		setError(null)
		let data: LoanCalculation | null = null

		if (!disabled) {
			try {
				let response: Response | undefined = undefined
				response = await _getLoanShareCalculation(loanUUID, filters)

				if (response && response.ok) {
					const res = await response.json()

					if (
						res.loanShareCalculation &&
						typeof res.loanShareCalculation === 'object'
					) {
						data = res.loanShareCalculation
					}
				} else {
					setError('Failed to fetch loan')
				}
			} catch (err) {
				console.error('Error fetching loan:', err)
				setError('An error occurred while fetching loan')
			}
		}
		setCalculation(data)
		setLoading(false)
	}, [loanUUID, filters, disabled])

	useEffect(() => {
		doQuery()
	}, [doQuery])

	return {
		calculation,
		loading,
		error,
		refresh: doQuery,
	}
}

export default useLoanShareCalculation
